<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add @invoke-method="invokeMethod($event)" action="startPackingList" perm="packing_lists.create"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetPackingLists()"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams" @open="getArrayData()">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams" placeholder="packing_list_search"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.company_id"
                                            :label="$t('lang.company_id')"
                                            :items="customer_options"
                                            item-value="company_id"
                                            item-text="company"
                                            prepend-icon="business"
                                            single-line
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="packing_lists" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="$router.push({ name: 'packing_list_profile', params: { id: props.item.packing_list_id } })">
                                <td>{{ props.item.packing_list_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td style="white-space: pre">{{ props.item.ship_to_address }}</td>
                                <td class="text-center">
                                    <v-btn
                                        icon
                                        v-if="props.item.has_bol == '1'"
                                        @mouseup.left.stop="$router.push({ name: 'bill_of_lading', params: { id: props.item.bol_id } })"
                                    >
                                        <v-icon :color="props.item.bol_class">{{ props.item.bol_icon }}</v-icon>
                                    </v-btn>
                                    <v-icon v-else class="unselectable" :color="props.item.bol_class" @mouseup.left.stop>{{ props.item.bol_icon }}</v-icon>
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        icon
                                        v-if="props.item.has_invoice == '1' && hasPerm('invoices.read')"
                                        @mouseup.left.stop="$router.push({ name: 'invoice', params: { id: props.item.invoice_id } })"
                                    >
                                        <v-icon color="success">attach_money</v-icon>
                                    </v-btn>
                                    <v-icon v-else :color="props.item.has_invoice == '1' ? 'success' : 'blue-grey lighten-3'" @mouseup.left.stop
                                        >attach_money</v-icon
                                    >
                                </td>
                                <td>{{ props.item.date_shipped }}</td>
                                <td class="text-center">
                                    <v-btn v-if="hasPerm('packing_lists.update')" icon @mouseup.left.stop="setLastPackUpdate(props.item)">
                                        <v-icon :color="props.item.shipped_class">{{ props.item.shipped_icon }}</v-icon>
                                    </v-btn>
                                    <v-icon v-else :color="props.item.shipped_class">{{ props.item.shipped_icon }}</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="packing_lists"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="create_dialog" :max-width="current_customer != null ? '700' : '500'">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ current_customer == null ? $t("lang.select_a_company") : $t("lang.create_packing_list") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="
                                create_dialog = false;
                                current_customer = null;
                            "
                            :dialog-status="create_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="create_packing">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            :focus="create_dialog"
                                            v-model="packing_list.company_id"
                                            :label="`${$t('lang.company')} *`"
                                            :items="customer_options"
                                            item-text="company"
                                            item-value="company_id"
                                            :rules="ifValid('packing_list.company_id')"
                                            :append-icon="current_customer != null ? 'lock' : '$vuetify.icons.dropdown'"
                                            :readonly="current_customer != null"
                                            :class="{ 'prevent-click': current_customer != null }"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="current_customer != null">
                                    <v-flex xs12 sm6>
                                        <bc-autocomplete
                                            v-model="packing_list.ship_to_address_id"
                                            :label="`${$t('lang.ship_to_address_id')} *`"
                                            :items="shipping_addresses || []"
                                            item-value="entity_addresses_id"
                                            item-text="full_single_line_address"
                                            :no-data-text="shipping_addresses.length > 0 ? $t('lang.no_data_available') : $t('lang.none_set_add_from_company')"
                                            clearable
                                            @click:clear="
                                                $nextTick(() => {
                                                    packing_list.ship_to_address_id = '';
                                                })
                                            "
                                            :rules="ifValid('packing_list.ship_to_address_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-autocomplete
                                            v-model="packing_list.sold_to_address_id"
                                            :label="`${$t('lang.sold_to_address_id')} *`"
                                            :items="billing_addresses || []"
                                            item-value="entity_addresses_id"
                                            item-text="full_single_line_address"
                                            :no-data-text="billing_addresses.length > 0 ? $t('lang.no_data_available') : $t('lang.none_set_add_from_company')"
                                            clearable
                                            @click:clear="
                                                $nextTick(() => {
                                                    packing_list.sold_to_address_id = '';
                                                })
                                            "
                                            :rules="ifValid('packing_list.sold_to_address_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <bc-autocomplete
                                            v-model="packing_list.payment_term_id"
                                            :label="`${$t('lang.payment_term')} *`"
                                            :items="payment_terms"
                                            item-value="payment_term_id"
                                            item-text="description"
                                            :rules="ifValid('packing_list.payment_term_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <bc-date-picker
                                            v-model="packing_list.date_shipped"
                                            :label="$t('lang.date_shipped')"
                                            :rules="ifValid('packing_list.date_shipped')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <bc-autocomplete
                                            v-model="packing_list.carrier_id"
                                            :label="$t('lang.carrier_id')"
                                            :items="shipping_carriers"
                                            item-value="company_id"
                                            item-text="company"
                                            :rules="ifValid('packing_list.carrier_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="current_customer != null" color="secondary" @mouseup.left="resetForm()">
                            <v-icon class="mr-1">keyboard_return</v-icon>
                            {{ $t("lang.back") }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            flat
                            @mouseup.left="
                                create_dialog = false;
                                current_customer = null;
                            "
                            >{{ $t("lang.cancel") }}</v-btn
                        >
                        <v-btn v-if="current_customer == null" color="success" @mouseup.left="getCustomer(packing_list.company_id)">{{
                            $t("lang.continue")
                        }}</v-btn>
                        <v-btn v-else color="success" @mouseup.left="createPackingList()">{{ $t("lang.create") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.packing_list_number_short"), sortable: false },
                { text: this.$t("lang.company"), sortable: false },
                { text: this.$t("lang.ship_to_address_id"), sortable: false },
                { text: this.$t("lang.bol_id"), sortable: false, align: "center" },
                { text: this.$t("lang.invoice"), sortable: false, align: "center" },
                { text: this.$t("lang.date_shipped"), sortable: false },
                { text: this.$t("lang.shipped"), sortable: false, align: "center" },
            ],
            customers: null,
            packing_list: {
                company_id: "",
                sold_to_address_id: "",
                ship_to_address_id: "",
                date_shipped: "",
                carrier_id: "",
                payment_term_id: "",
            },
            current_obj: null,
            current_customer: null,
            filter: {
                search: "",
                company_id: "",
                page_size: 0,
                page_num: 0,
            },
            salesman: null,
            billing_addresses: [],
            shipping_addresses: [],
            company_id: null,
            create_dialog: false,
            packing_list_dialog: false,
            update_pack_timer: null,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "startPackingList", perms: ["packing_lists.create"] },
                { title: this.$t("lang.refresh"), action: "dbGetPackingLists" },
            ],
            last_pack_updated_id: null,
            dbGetPackingLists: _.debounce(this.getPackingLists, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchPackingList", {
                url: "packing_lists",
                method: "get",
                stateProperty: "packing_lists",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.packing_lists) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchPackingList", {
                url: "packing_lists",
                method: "get",
                stateProperty: "packing_lists",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.packing_lists) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_packing_list: (state) => state.validation.rules_packing_list,
            default_filter: (state) => state.packing_lists.packing_lists_filter,
            page: (state) => state.packing_lists.page,
            packing_lists: (state) => state.packing_lists.packing_lists,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carrier_options,
            customer_options: (state) => state.customers.customer_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        ...mapActions(["fetchPaymentTerms", "fetchCustomers", "fetchCustomer", "fetchPeople", "fetchShippingCarriers"]),
        setLastPackUpdate(packing_list) {
            if (packing_list && (this.last_pack_updated_id != packing_list.packing_list_id || !this.update_pack_timer)) {
                clearTimeout(this.update_pack_timer);
                this.last_pack_updated_id = packing_list.packing_list_id;
                this.updateShipped(packing_list);
                this.update_pack_timer = setTimeout(() => {
                    this.update_pack_timer = null;
                }, 1500);
            }
        },
        resetForm() {
            this.current_customer = null;
            this.assignObj(this.packing_list, {
                sold_to_address_id: "",
                ship_to_address_id: "",
                date_shipped: "",
                carrier_id: "",
                payment_term_id: "",
            });
        },
        getCustomer(company_id = null) {
            this.fetchCustomer({ id: company_id }).then((data) => {
                if (typeof data !== "undefined" && data.customer) {
                    this.current_customer = data.customer;
                    this.assignObj(this.packing_list, data.customer);
                    if (data.customer.entity_addresses) {
                        let grouped = _.groupBy(this.current_customer.entity_addresses, "address_type");
                        this.billing_addresses = grouped && grouped.billing ? grouped.billing : [];
                        if (this.billing_addresses.length > 0) this.packing_list.sold_to_address_id = this.billing_addresses[0].entity_addresses_id;

                        this.shipping_addresses = grouped && grouped.shipping ? grouped.shipping : [];
                        if (this.shipping_addresses.length > 0) this.packing_list.ship_to_address_id = this.shipping_addresses[0].entity_addresses_id;
                    } else {
                        this.billing_addresses = [];
                        this.shipping_addresses = [];
                    }
                    if (this.shipping_carriers.length == 0) this.fetchShippingCarriers({ body: { options: 1, department_id: "2" } });
                    if (this.salesman == null) this.getEmployees();
                    if (this.payment_terms.length == 0) this.fetchPaymentTerms({ body: { options: 1 } });

                    this.$store.commit("validationOff");
                }
                this.$store.commit("toggleModalLoader", false);
            });
        },
        getArrayData() {
            if (this.customers == null) this.getCustomers();
        },
        closePackingListDialog() {
            this.packing_list_dialog = false;
            this.$refs.delete_packing_list.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getPackingLists() {
            this.startLoader();
            this.$store
                .dispatch("fetchPackingList", {
                    url: "packing_lists",
                    method: "get",
                    stateProperty: "packing_lists",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.packing_list_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        getCustomers() {
            this.fetchCustomers({ body: { options: 1 } });
            // this.$store
            //     .dispatch("fetchCustomers", {
            //         url: "customers",
            //         method: "get",
            //     })
            //     .then((data) => {
            //         if (typeof data !== "undefined") {
            //             this.customers = data.customers;
            //         }
            //     });
        },
        modifyPackingList(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("packing_list")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchPackingList", {
                                pk: "packing_list_id",
                                id: id,
                                url: `packing_lists/${id ? id : ""}`,
                                method: method,
                                stateProperty: "packing_lists",
                                mutate: true,
                                body: this.packing_list,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closePackingListDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        createPackingList() {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("create_packing")) {
                    this.$store.commit("toggleModalLoader", true);
                    this.$store
                        .dispatch("fetchPackingList", {
                            url: `packing_lists/`,
                            method: "post",
                            body: this.packing_list,
                        })
                        .then((data) => {
                            if (data && data.code == "200" && data.packing_list) {
                                // this.closePackingListDialog();
                                this.$store.commit("validationOff");
                                this.$router.push({ name: "packing_list_profile", params: { id: data.packing_list.packing_list_id } });
                            }
                            this.$store.commit("toggleModalLoader", false);
                        });
                }
            });
        },
        startPackingList() {
            this.getArrayData();
            this.create_dialog = true;
        },
        getShippingCarriers() {
            this.$store.dispatch("fetchShippingCarriers", {
                url: "shipping_carriers",
                method: "get",
                stateProperty: "shipping_carriers",
                commit: true,
                body: { options: 1, department_id: "2" },
            });
        },
        getEmployees() {
            this.$store
                .dispatch("fetchPeople", {
                    url: "people",
                    method: "get",
                    body: {
                        slug: "employee",
                    },
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.people) {
                        this.salesman = data.people;
                    }
                });
        },
        updateShipped(packing_list) {
            let shipped = packing_list.shipped == "1" ? "0" : "1";
            let packing_list_id = packing_list.packing_list_id;
            this.$store.dispatch("fetchPackingList", {
                id: packing_list_id,
                pk: "packing_list_id",
                url: `packing_lists/${packing_list_id}`,
                method: "patch",
                stateProperty: "packing_lists",
                dataProperty: "packing_list",
                mutate: true,
                body: {
                    shipped: shipped,
                },
            });
        },
    },
};
</script>
